import { ArrowRight, Sparkles, Truck } from "lucide-react"
import { Badge } from "@/components/ui/Badge"
import { fullDate, num } from "../format"
import type { Detail } from "../types"

// Sits under the product name, above the warehouse table. Incoming orders,
// one line each; an order still on its way after its ETA is marked past due.
// A new product says its pace counts only its days on sale.
export default function StockNotes({ detail }: { detail: Detail }) {
  return (
    <div className="overflow-hidden rounded-md border">
      {detail.days_on_sale !== null && (
        <div className="flex items-center gap-2 px-4 py-2.5 text-sm">
          <Sparkles className="h-4 w-4 shrink-0" />
          New product: first sold {detail.days_on_sale} days ago, so the daily move counts those {detail.days_on_sale} days, not 90.
        </div>
      )}
      {detail.incoming.length === 0 ? (
        <div className="flex items-center gap-2 border-t px-4 py-2.5 text-sm first:border-t-0">
          <Truck className="h-4 w-4 shrink-0" />
          No incoming orders
        </div>
      ) : (
        detail.incoming.map((line, i) => (
          <div key={`${line.order_no}-${i}`} className="flex items-center gap-2 border-t px-4 py-2.5 text-sm first:border-t-0">
            <Truck className="h-4 w-4 shrink-0" />
            <span className="flex flex-wrap items-center gap-x-1.5">
              Incoming: <span className="font-semibold tabular-nums">{num(line.quantity)}</span>
              {line.arrives_on ? <>on {fullDate(line.arrives_on)}</> : <>, date unknown</>}
              {line.arrives_on && line.arrives_on < detail.today && <Badge variant="warning">Past due</Badge>}
              <span>({[line.order_no && `order ${line.order_no}`, line.status].filter(Boolean).join(", ")})</span>
              {line.arrives_on && (
                <>
                  <ArrowRight className="h-3.5 w-3.5" />
                  stock lasts <span className="font-semibold tabular-nums">{line.lasts_days === null ? "—" : `${num(line.lasts_days)} days`}</span> after it lands
                </>
              )}
            </span>
          </div>
        ))
      )}
    </div>
  )
}
